import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PagedResult } from '../models/paged-result';
import { IPagedRequest, PagedRequest } from '../models/paged-request';
import { API_HOST } from './api-host.token';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseApiService<T> {
  private httpClient = inject(HttpClient);
  private apiHost = inject(API_HOST);
  protected defaultVersion = 'v1.0';

  // eslint-disable-next-line @angular-eslint/prefer-inject
  protected constructor(protected baseEndpoint: string) {}

  public getPagedResult(pagedRequest?: IPagedRequest, additionalParams?: Record<string, string | number>) {
    pagedRequest ??= new PagedRequest(1, 20);

    let params = new HttpParams();
    for (const key in pagedRequest) {
      if (key === 'kind') {
        continue;
      }
      params = params.append(key, (pagedRequest as never)[key]);
    }

    if (additionalParams) {
      for (const key in additionalParams) {
        const value = additionalParams[key];
        if (value != null) {
          params = params.append(key, value.toString());
        }
      }
    }

    return this.httpClient.get<PagedResult<T>>(`${this.apiHost}/${this.defaultVersion}/${this.baseEndpoint}`, { params });
  }

  public get(id: string) {
    return this.httpClient.get<T>(`${this.apiHost}/${this.defaultVersion}/${this.baseEndpoint}/${id}`);
  }

  public create<R = T>(object: R): Observable<T>;
  public create<R = T>(object: R): Observable<R> {
    return this.httpClient.post<R>(`${this.apiHost}/${this.defaultVersion}/${this.baseEndpoint}`, object);
  }

  public update<R = T>(id: string, object: R) {
    return this.httpClient.put<R>(`${this.apiHost}/${this.defaultVersion}/${this.baseEndpoint}/${id}`, object);
  }

  /**
   * Send an HTTP request to a subresource of the main endpoint.
   */
  public sendSubresource<R = void>(method: 'GET' | 'POST' | 'PUT' | 'DELETE', id: number | string, subPath: string, body: unknown | null) {
    const normalized = subPath.startsWith('/') ? subPath.slice(1) : subPath;
    const url = `${this.apiHost}/${this.defaultVersion}/${this.baseEndpoint}/${id}/${normalized}`;
    return this.httpClient.request<R>(method, url, body == null ? undefined : { body });
  }
}
